/** `development` | `production` (or any label set in VITE_APP_ENV, e.g. `staging`): the nav rail's environment badge, as the old top bar's. */
export const APP_ENV: string = import.meta.env.VITE_APP_ENV || (import.meta.env.DEV ? 'development' : 'production');
